import type { PageData } from '@wix/thunderbolt-becky-types'
import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import { isLandingPage, isRoutablePage } from '@wix/thunderbolt-commons'
import type { LandingPagePageConfig } from '../types'
import { name } from '../symbols'

export const landingPagePageConfig: PageConfigFn<LandingPagePageConfig> = ({ api }: VsmContext, pageId: string) => {
	const pageData = api.page.getPageData(pageId)

	if (!pageData) {
		return {
			shouldLoadPageFeature: false,
		}
	}

	const isMobileView = api.env.isMobileView()
	const isCurrentPageRoutable = isRoutablePage(pageData)
	const allPagesData = api.page.getPageDataItems()
	let siteHasLandingPages = false

	for (const page of Object.values(allPagesData)) {
		if (isLandingPage(page, isMobileView)) {
			siteHasLandingPages = true
			break
		}
	}

	if (!siteHasLandingPages || !isCurrentPageRoutable) {
		return { shouldLoadPageFeature: false }
	}

	const isCurrentPageLandingPage = isLandingPage(pageData, isMobileView)

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			isLandingPage: isCurrentPageLandingPage,
		},
	}
}

export const landingPagePageConfigEntry: PageConfigEntry<LandingPagePageConfig> = {
	name,
	pageConfig: landingPagePageConfig,
	experiment: 'specs.thunderbolt.vsmLandingPageConfig',
}
